import { PatientMatchStatus, clientsWithAppointmentList, getAllStates } from '@uplift/api';
import { CalendarDateService } from '@uplift/services';
import { PatientRow } from './components/PatientsTable/PatientsTable.types';
import { useQuery } from '@tanstack/react-query';
import { State } from '@uplift/types';
import { formatUserFullName } from '@uplift/utils';


export const useAllPatientsData = () => useQuery({
  queryKey: [ 'clients-with-appointment-list' ],
  queryFn: async () => {
    const statesData = await getAllStates();
    const appointmentData = await clientsWithAppointmentList({ all_matching_states: true });
    const statesById = statesData.data.reduce((prev, curr) => ({ ...prev, [curr.id]: curr }), {} as Record<string, State>);

    const allPatients = appointmentData.data.map(client => {
      const state = statesById[client.patientProfile.address?.stateId];

      return {
        id: client.patient.id,
        matchId: client.match.id,
        name: formatUserFullName({
          firstName: client.patient.firstName,
          lastName: client.patient.lastName,
          preferredFirstName: client.patientProfile.preferredName,
          fallback: client.patient.email,
        }),
        lastSession: client.lastAppointment?.fromDatetime && CalendarDateService.date(client.lastAppointment.fromDatetime),
        nextSession: client.nextAppointment?.fromDatetime && CalendarDateService.date(client.nextAppointment.fromDatetime),
        location: client.patientProfile.address ? `${client.patientProfile.address.city}, ${state?.shortName}` : null,
        status: client.status
      };
    });

    const activePatients: PatientRow[] = allPatients.filter(x => x.status === PatientMatchStatus.active);
    const inactivePatients: PatientRow[] = allPatients.filter(x => x.status !== PatientMatchStatus.active);

    return {
      all: allPatients,
      active: activePatients,
      inactive: inactivePatients,
    };
  }
});
